module.exports = __webpack_public_path__ + "img/banner-1.4a4c2806.jpg";